module.exports = __webpack_public_path__ + "static/media/Serge_Bellon_ID.6c3c2fac.JPG";